import { z } from "zod";

export const deleteAccountSchema = z.object({
  emailOrConnectId: z.union([
    z
      .string()
      .email("Veuillez entrer un email ou identifiant Connect’Events valide"),
    z.string().length(10),
  ]),
  password: z.string(),
});

export const defaultDeleteAccountValues = {
  emailOrConnectId: "",
  password: "",
};

export type DeleteAccountForm = z.infer<typeof deleteAccountSchema>;
